import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { BeforeAfter } from './components/BeforeAfter';
import { ForWhom } from './components/ForWhom';
import { Manuals } from './components/Manuals';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Scarcity } from './components/Scarcity';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Author } from './components/Author';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { SalesPopup } from './components/SalesPopup';
export function App() {
  return <div className="min-h-screen w-full bg-ink-950 font-sans text-white antialiased" data-id="element-0" data-mp="28s31dk1f0dz5">
      <MetaPixel data-id="element-1" data-mp="23t8h0dnsuhcx" />
      <SalesPopup data-id="element-2" data-mp="3ijxoypkvdyjd" />

      <main data-id="element-3" data-mp="3ikh5q2ysagvt">
        <Hero data-id="element-4" data-mp="3iiwf2oflbi38" />
        <BeforeAfter data-id="element-5" data-mp="3ijfx0558q6h9" />
        <ForWhom data-id="element-6" data-mp="3ihv0i9zd8dgr" />
        <Manuals data-id="element-7" data-mp="3mlj82snzz920" />
        <InstantAccess data-id="element-8" data-mp="3ml12v6jcxkhy" />
        <Bonuses data-id="element-9" data-mp="3mk8710lxsfel" />
        <Offer data-id="element-10" data-mp="3mjq1tehaqquj" />
        <Scarcity data-id="element-11" data-mp="3mjgclt42snpw" />
        <Testimonials data-id="element-12" data-mp="3rcj6618urx63" />
        <Guarantee data-id="element-13" data-mp="3rbzo8kj7d8s2" />
        <Author data-id="element-14" data-mp="3rdkgu4lyihna" />
        <Faq data-id="element-15" data-mp="3rd191gq0t9mz" />
        <FinalCta data-id="element-16" data-mp="3relumgucxi8p" />
      </main>

      <Footer data-id="element-17" data-mp="6hq1ea16ddl" />
      <FloatingCta data-id="element-18" data-mp="4wupmfw6qeo" />
    </div>;
}